function getQuantityVariant() {
  let select = document.querySelector('[name="id"]');
  return Number(select.options[select.selectedIndex].getAttribute("data-quantity"));
}

function getRealQuantityDisplay() {
  let variantQuantity = getQuantityVariant();
  return variantQuantity > 8 ? variantQuantity : Math.max(1, Math.ceil(variantQuantity / 2));
}

function getText() {
  let quantity = getRealQuantityDisplay();

  if (quantity <= 0) {
    return 'Sold Out';
  } else if (quantity >= 9) {
    return 'In Stock';
  } else {
    let word;
    if (quantity === 1) word = 'One';
    else if (quantity === 2) word = 'Two';
    else if (quantity === 3) word = 'Three';
    else if (quantity === 4) word = 'Four';
    else if (quantity === 5) word = 'Five';
    else if (quantity === 6) word = 'Six';
    else if (quantity === 7) word = 'Seven';
    else if (quantity === 8) word = 'Eight';
    return `${word} Left`;
  }

  //return quantity >= 9 ? `In Stock` : quantity <= 0 ? `Sold Out` : `${quantity} Left`;
}

function changeScarcity() {
  let text = getText();
  let textElement = document.querySelector(".product-add-to-cart-button");

  textElement.setAttribute("scarcity-message" , text );
  textElement.innerHTML = `Add to bag - <span class="font-500">${text}</span>`;
}

function setEvents() {
  let variantButtons = document.querySelectorAll(".product-swatch__input");
  variantButtons.forEach((element) => element.addEventListener("change", changeScarcity));
}

(() => {
  setEvents();
  if (window.location.search.includes("variant")) changeScarcity();
})();